import { render } from 'preact';
import { App } from './app';

const container = document.getElementById('homelander');

const user = window.novelizing.user;
const genre = window.novelizing.genre;
const featuredGenres = window.novelizing.featuredGenres;

if (container) {
  container.innerHTML = '';
  render(
    <App user={user} genre={genre} featuredGenres={featuredGenres} />,
    container,
  );
}
